import './TimeOption.scss';

import React, { useCallback, useEffect, useRef } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import PropTypes from 'prop-types';

import { cxHelpers } from 'util/className';

const { cx } = cxHelpers('TimeOption');

const TimeOption = ({ option, selected, onSelect }) => {
  const ref = useRef(null);
  const handleClick = useCallback(
    e => {
      e.stopPropagation();
      e.preventDefault();
      onSelect(option);
    },
    [onSelect, option]
  );

  useEffect(() => {
    if (selected) {
      // eslint-disable-next-line no-unused-expressions
      ref.current?.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
      });
    }
  }, [selected]);

  return (
    <Box
      w="100%"
      className={cx({
        selected,
      })}
      onClick={handleClick}
    >
      <Text variant="bodySm">
        <span ref={ref}>{option}</span>
      </Text>
    </Box>
  );
};

TimeOption.propTypes = {
  option: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

export default TimeOption;
